import { readImageUpload } from './imageUpload';

const MAX_LOGO_BYTES = 512 * 1024;

export const readLogoUpload = (file: File): Promise<string> =>
  readImageUpload(file, MAX_LOGO_BYTES, 'editor.uploadLabels.logo');
